import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import About from "@/pages/About";
import ProductDetail from "@/pages/ProductDetail";
import Products from "@/pages/Products";
import FarmerNetwork from "@/pages/FarmerNetwork";
import FarmerInterest from "@/pages/FarmerInterest";
import FPOInterest from "@/pages/FPOInterest";
import BuyerInterest from "@/pages/BuyerInterest";
import Knowledge from "@/pages/Knowledge";
import FPOPartnership from "@/pages/FPOPartnership";
import Buyers from "@/pages/Buyers";
import Contact from "@/pages/Contact";
import Admin from "@/pages/admin/Admin";
import FarmerDashboard from "@/pages/farmer/FarmerDashboard";
import { AuthProvider, RequireAuth } from "@/auth/AuthProvider";
import LoginLanding from "@/pages/auth/LoginLanding";
import FarmerLogin from "@/pages/auth/FarmerLogin";
import StaffLogin from "@/pages/auth/StaffLogin";
import { ForgotPassword, ResetPassword } from "@/pages/auth/PasswordReset";

function App() {
  return (
    <div className="App min-h-screen bg-[var(--tr-bone)] text-[var(--tr-text)]">
      <BrowserRouter>
        <AuthProvider>
          <Navbar />
          <main data-testid="app-main">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/products" element={<Products />} />
              <Route path="/products/:slug" element={<ProductDetail />} />
              <Route path="/farmer-network" element={<FarmerNetwork />} />
              <Route path="/farmer-interest" element={<FarmerInterest />} />
              <Route path="/fpo-interest" element={<FPOInterest />} />
              <Route path="/buyer-interest" element={<BuyerInterest />} />
              <Route path="/knowledge" element={<Knowledge />} />
              <Route path="/fpo-partnership" element={<FPOPartnership />} />
              <Route path="/buyers" element={<Buyers />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/login" element={<LoginLanding />} />
              <Route path="/login/farmer" element={<FarmerLogin />} />
              <Route path="/login/staff" element={<StaffLogin />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password/:token" element={<ResetPassword />} />
              <Route path="/farmer/*" element={
                <RequireAuth roles={["farmer"]}>
                  <FarmerDashboard />
                </RequireAuth>
              } />
              <Route path="/admin/*" element={
                <RequireAuth roles={["administrator", "super_administrator"]}>
                  <Admin />
                </RequireAuth>
              } />
            </Routes>
          </main>
          <Footer />
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
